import { cn } from '@/lib/cn';

export interface SearchSectionHeaderProps {
  label: string;
  count?: number | string;
  className?: string;
}

export function SearchSectionHeader({ label, count, className }: SearchSectionHeaderProps) {
  const showCount = count !== undefined && count !== '' && count !== null;
  return (
    <div
      className={cn(
        'flex h-7 items-center justify-between px-3 py-2 text-[11px] text-text-secondary',
        className,
      )}
    >
      <span className="font-bold">{label}</span>
      {showCount ? <span>{count}</span> : null}
    </div>
  );
}
